<style lang="less" scoped>
@import url('../../../style/common/variable.less');
@media screen and (min-width: @max-screen)
{
  .box{width: 1215px;margin:auto;}
  h2{text-align: left;margin-left: 15px;letter-spacing: 2px;}
  .rightBox{width: 953px;display: flex;flex-direction: column;justify-content:center;align-items:center;}
  .xtitle{margin-bottom: 30px;}
  .xcontent{width: 100%;height: 1045px;font-family: Microsoft YaHei;font-size: 18px;font-weight: normal;font-stretch: normal;line-height: 47px;letter-spacing: 0px;color: #333333;text-align: left;margin-bottom: 20px;overflow:auto;overflow-x: hidden;}
  .ximg{width: 100%;height: 751px;border: solid 1px #707070;background: url('../../../../static/hzxmkyxm/4.png');background-size: 100% 100%;}
}

@media screen and (max-width: @max-screen)
{
  .box{width: 100%;margin:auto;}
  .rightBox{width: 98%;margin: auto;}
  h2{letter-spacing: 2px;font-size: 16px;}
  .xcontent{width: 100%; height: 100%;font-family: Microsoft YaHei;font-size: 18px;font-weight: normal;font-stretch: normal;line-height: 47px;letter-spacing: 0px;color: #333333;text-align: left;margin-bottom: 20px;overflow:auto;overflow-x: hidden;}
  .ximg{width: 100%;border: solid 1px #707070;background: url('../../../../static/hzxmkyxm/4.png');background-size: 100% 100%;}
}

.kyxmDetails{position: relative;width: 100%;flex-direction: row;justify-content:space-between;margin: 0;padding: 0;background: #fff;font-family: Microsoft YaHei;margin-bottom: 40px;}
// .box{width: 1215px;margin:auto;}
// h2{text-align: left;margin-left: 15px;letter-spacing: 2px;}
.titleCard, .editorCard, .InfoCard, .InteresCard, .aPic, .pics{background-color: #ffffff;box-shadow: 0px 0px 3px 2px rgb(240, 239, 239);border-radius: 5px;text-align: left;}
.leftBox{width: 227px;float: left;margin-right: 20px;margin-left:15px}
.leftmenu{width: 100%;height: 606px;margin-bottom: 16px;
.menuitem{width: 227px;height: 78px;background-color: #f8f9fb;margin-bottom: 10px;
.icon{width: 11px;height: 11px;margin-left: 11px;margin-top: 17px;}
.label1{width: 90px;height: 24px;margin-left: 14px;margin-top: 9px;
span{float: left;text-align: left;font-family: Microsoft YaHei;font-size: 18px;font-weight: 800;font-stretch: normal;line-height: 32px;letter-spacing: 0px;color: #00338b;}
}
.label2{width: 180px;height: 36px;margin-left: 36px;margin-top: 5px;flex-wrap: wrap;word-break:break-all;
	display:-webkit-box;
	-webkit-line-clamp:2;
	-webkit-box-orient:vertical;
	overflow:hidden;
span{text-align: left;font-family: Microsoft YaHei;font-size: 18px;font-weight: normal;float: left;font-stretch: normal;line-height: 18px;letter-spacing: 0px;color: #666666;}
}
}
}
.jcss{width: 100%;height: 481px;margin-bottom: 20px;
.jtitle{width: 72px;height: 24px;margin-bottom: 10px;
span{font-family: Microsoft YaHei;font-size: 18px;font-weight: 800;line-height: 32px;letter-spacing: 0px;color: #00338b;}
}
.jmain{width: 227px;height: 447px;}
}
.msg{width: 100%;background-color: #f8f9fb;height: 251px;
 ul{list-style: none;margin-top: -10px;margin-left: -40px;}
li{width:227px;margin: 12px 0px;float: left;
.left{width: 72px;height: 25px;font-family: Microsoft YaHei;font-size: 18px;font-weight: normal;font-stretch: normal;line-height: 25px;letter-spacing: 0px;color: #00338b;font-weight: 800;float: left;margin-left: 10px;}
.right{width: 116px;height: 25px;font-family: Microsoft YaHei;font-size: 18px;font-weight: normal; flex-wrap: wrap;font-stretch: normal;line-height: 25px;letter-spacing: 0px;color: #333333;margin-right: 10px;}
}
}
.titleCard{width: 330px;height: 335px;margin-bottom: 24px;
  ul{list-style: none;margin-top: -10px;margin-left: -40px;}
  li{width:320px;margin: 12px 0px;}
  li:nth-child(3){width:320px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  li:nth-child(5){width:320px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  .left{font-weight: 600;}
}
.editorCard{width: 330px;height: 400px;
  ul{list-style: none;margin-top: -10px;margin-left: -40px;}
  li{width:320px;margin: 12px 0px;}
  li:nth-child(3){width:320px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  li:nth-child(5){width:320px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  .left{font-weight: 600;}
  .iconwei{color: rgb(209, 24, 24);margin: 0px 5px;}
  .iconyi{color: rgb(43, 214, 27);margin: 0px 5px;}
  .el-button{width: 140px;height: 42px;margin-left:88px;font-size: 16px;border-radius: 5px;box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.16);margin-top: 30px;}
}
// .rightBox{width: 953px;display: flex;flex-direction: column;justify-content:center;align-items:center;
.map{width: 100%;height: 605px;margin-bottom: 26px;}
.xmgk{width: 100%;height: 1123px;margin-bottom: 30px;
.xtitle{width: 100%;height: 40px;border-bottom: solid 1px #d2d2d2;
.label{width: 80px;height: 26px;margin-bottom: 2px;
span{font-family: Microsoft YaHei;font-size: 20px;font-weight: 800;font-stretch: normal;line-height: 26px;letter-spacing: 0px;color: #0067b5;}
}
.bot1{border-width: 5px;border-style: solid dashed dashed;border-color: transparent transparent #0067b5;margin-left: 38px;width: 0;}
.line{width: 85px;height: 3px;background-color: #0067b5;}
.more{width: 32px;height: 19px;float: right;margin-top: -28px;margin-right: 16px;
span{font-family: Alibaba-PuHuiTi-R;font-size: 14px;font-weight: normal;font-stretch: normal;line-height: 25px;letter-spacing: 1px;color: #666666;}
}
.bot2{border-width: 5px;border-style: solid dashed dashed;border-color: transparent transparent transparent #0067b5;margin-left: 38px;width: 0;margin-top: -19px;float:right;}
}
// .xcontent{width: 100%;height: 1045px;font-family: Microsoft YaHei;font-size: 18px;font-weight: normal;font-stretch: normal;line-height: 47px;letter-spacing: 0px;color: #333333;text-align: left;margin-bottom: 20px;overflow:auto;overflow-x: hidden;}
// .ximg{width: 100%;height: 751px;border: solid 1px #707070;background: url('../../../../static/hzxmkyxm/4.png');background-size: 100% 100%;}
}
.interescard{width: 100%;height: 283px;margin-bottom: 38px;
.ititle{width: 100%;height: 40px;margin-bottom: 23px;border-bottom: solid 1px #d2d2d2;
.label{width: 80px;height: 26px;margin-bottom: 2px;
span{font-family: Microsoft YaHei;font-size: 20px;font-weight: 800;font-stretch: normal;line-height: 26px;letter-spacing: 0px;color: #0067b5;}
}
.bot1{border-width: 5px;border-style: solid dashed dashed;border-color: transparent transparent #0067b5;margin-left: 38px;width: 0;}
.line{width: 85px;height: 3px;background-color: #0067b5;}
}
.picBox{width: 100%;height: 222px;
ul{list-style: none;display: flex; margin-left: -40px;width: 100%;height: 100%;}
  li{width: 230px;height: 100%;margin-right: 9px;}
  li:hover{box-shadow: 0px 0px 3px 1px rgb(228, 227, 227);cursor: pointer;}
  li:hover img {opacity:0.8;}
  .pic{width: 100%;height: 168px;overflow:hidden;margin-bottom: 14px;}
  .title{font-size: 16px;width: 167px;height: 21px;margin-left:10px;margin-top: 0px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  .title:hover{color: #13569e;}
  .current{display: none;}
}
}

</style>

<template>
  <div class="kyxmDetails">
    <div class="box">
      <h2> {{ title }} </h2>
      <div class="leftBox" v-if='ifShowFlag'>
        <div class="leftmenu">
          <div class="menuitem" v-for="(item,index) in menudata" :key="index">
            <div style="display: flex;">
              <div class="icon"><img style="width: 100%;height: 100%;" :src="item.img" /></div>
              <div class="label1"><span>{{item.label1}}</span></div>
            </div>
            <div class="label2"><span>{{item.label2}}</span></div>
          </div>
        </div>
        <div class="jcss">
          <div class="jtitle"><span>基础设施</span></div>
          <div class="jmain">
            <!-- <img :src="this.jcssimg" alt="" > -->
            <el-image
              style="width: 227px; height: 447px"
              :src="this.jcssimg"
              :preview-src-list="srcList">
            </el-image>
          </div>
        </div>
        <div class="msg">
          <ul>
            <li><span class="left" style="margin-left: 20px;">联系人：</span><span class="right"> {{message.name}} </span></li>
            <li><span class="left">电话：</span><span class="right"> {{message.telephone}} </span></li>
            <li><span class="left">手机：</span><span class="right"> {{message.mobile}} </span></li>
            <li><span class="left">地区：</span><span class="right"> {{message.dq}} </span></li>
            <li><span class="left">地址：</span><span class="right"> {{message.address}} </span></li>
          </ul>
        </div>
        <div class="jcss">
          <div class="jtitle"><span>免责声明</span></div>
          <div class="jmain">
            <p style="text-align: left; text-indent: 2em;">本网站发布项目推荐信息均由相关公司提供，不声明或保证所提供信息的准确性和完整性。用户应自行判断并承担所有风险。本免责声明的解释权归本网站所有。</p>
          </div>
        </div>
      </div>
      <div class="rightBox">
        <!-- <div class="map"></div> -->
        <div class="xmgk">
          <div class="xtitle">
            <div class="label"><span>项目概况</span></div>
            <div class="bot1"></div>
            <div class="line"></div>
            <!-- <div class="more"><span>更多</span></div>
            <div class="bot2"></div> -->
          </div>
          <div class="xcontent" v-html="xcontent"></div>
          <!-- <div class="ximg"></div> -->
        </div>
        <div id="map" class="map">
        </div>
        <div class="interescard" v-if="ifShowFlag">
          <div class="ititle">
            <div class="label"><span>猜你喜欢</span></div>
            <div class="bot1"></div>
            <div class="line"></div>
          </div>
          <div class="picBox">
            <ul>
              <li v-for="(item,index) in datalist" :key="index" @click="clickPic(item)">
                <img class="pic" :src="item.pic">
                <p class="title"> {{ item.title }} </p>
              </li>
            </ul>
            <p class="current"> {{ current }} </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 何宽 合作项目下的矿业项目专场详细信息页面
 */
import filters from '../method/filter.js'
import $ from 'jquery'
import 'ol/ol.css'
import Map from 'ol/Map'
import TileLayer from 'ol/layer/Tile'
import XYZ from 'ol/source/XYZ'
import View from 'ol/View'
import MousePosition from 'ol/control/MousePosition'
import {defaults as defaultControls} from 'ol/control'
import {createStringXY} from 'ol/coordinate'
import { Circle as CircleStyle, Fill, Stroke, Icon, Style } from 'ol/style'
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import GeoJSON from 'ol/format/GeoJSON'
import MultiPoint from 'ol/geom/MultiPoint'
export default {
  name: '',
  mixins: [filters],
  data()
  {
    return {
      title: '',
      menudata:
      [
        {
          img: require('../../../../static/hzxmkyxm/1.png'),
          label1: '股权权属',
          label2: ''
        },
        {
          img: require('../../../../static/hzxmkyxm/1.png'),
          label1: '矿业权类型',
          label2: ''
        },
        {
          img: require('../../../../static/hzxmkyxm/1.png'),
          label1: '资源量',
          label2: ''
        },
        {
          img: require('../../../../static/hzxmkyxm/1.png'),
          label1: '合作意向',
          label2: ''
        },
        {
          img: require('../../../../static/hzxmkyxm/1.png'),
          label1: '项目优势',
          label2: ''
        },
        {
          img: require('../../../../static/hzxmkyxm/1.png'),
          label1: '地理位置',
          label2: ''
        },
        {
          img: require('../../../../static/hzxmkyxm/1.png'),
          label1: '发布时间',
          label2: ''
        }
      ],
      message: {},
      xcontent: {},
      infoObj: {},
      curContent: null,
      interestedList: [],
      show: false,
      current: 0,  // 点击加载更多的次数
      datalist: [], // 猜你喜欢数据临时存储容器
      companyID: null, // 公司ID
      polyData: [],
      jcssimg: '',
      ifShowFlag: true,
      srcList: []
    }
  },
  watch:
  {
    $route: {
      handler(nval, oval)
      {
        this.getCompany(nval.query.company)
        this.companyID = nval.query.id
        this.getdatas(+nval.query.id)
      },
      immediate: true
    }
  },
  mounted()
  {
    this.$nextTick(() =>
    {
      this.loadModules()
      //刷新窗口兼容IE
      setTimeout(() =>
      {
        window.map.updateSize()
      }, 1000)
    })

    if (window.innerWidth > 912)
      this.ifShowFlag = true
    else
      this.ifShowFlag = false
  },
  methods:
  {
    //加载底图
    loadModules()
    {
      var layer1 = new TileLayer({
        title: '矢量底图',
        source: new XYZ({
          url: 'https://t0.tianditu.gov.cn/DataServer?T=vec_w&tk=a777ec0e3970c43caf7735adffa9f11f&x={x}&y={y}&l={z}'
        }),
        visible: false
      })
      var layer2 = new TileLayer({
        title: '影像底图',
        source: new XYZ({
          url: 'https://t0.tianditu.gov.cn/DataServer?T=img_w&tk=a777ec0e3970c43caf7735adffa9f11f&x={x}&y={y}&l={z}'
        }),
        visible: true
      })
      var layer3 = new TileLayer({
        title: '中文注记',
        namee: 'ChineseNotes',
        source: new XYZ({
          url: 'https://t0.tianditu.gov.cn/DataServer?T=cva_w&tk=a777ec0e3970c43caf7735adffa9f11f&x={x}&y={y}&l={z}'
        }),
        visible: true
      })
      var layer4 = new TileLayer({
        title: '地形底图',
        source: new XYZ({
          url: 'https://t0.tianditu.gov.cn/DataServer?T=ter_w&tk=a777ec0e3970c43caf7735adffa9f11f&x={x}&y={y}&l={z}'
        }),
        visible: false
      })
      // 实例化鼠标位置控件
      const mousePositionControl = new MousePosition({
        coordinateFormat: createStringXY(9),
        projection: 'EPSG:4326',
        className: 'custom-mouse-position',
        target: 'map'
      })
      let map = new Map({
        target: 'map',
        layers: [layer1, layer2, layer4, layer3],
        overlays: [],
        view: new View({
          center: [108.21, 7.01],
          projection: 'EPSG:4326',
          zoom: 5
        }),
        controls: defaultControls().extend([mousePositionControl])
      })
      window.map = map
      this.Basemap = [{name: '矢量底图', layer: layer1}, {name: '卫星底图', layer: layer2}, {name: '地形底图', layer: layer4}]
    },
    //获取数据
    getdatas(num)
    {
      let paras1 = {cmd: 'query', _major: 11, _minor: 129, _exp: 'id=?', types: 'i', vals: num}
      window.post.getPost(paras1).then((ret) =>
      {
        this.jcssimg = ''
        if (ret[0].drawtype === 1)

          this.drawPoint(ret[0].lonlat)

        else
          this.drawPolygon(ret[0].lonlat)
        
        // this.menudatas = {title: ret[0].title, gqqs: ret[0].kaicaifangshi, kyqlx: ret[0].baojia, zycl: ret[0].ziyuanchuliang, hzfs: ret[0].hezuofangshi, xmys: ret[0].pingjunpinwei, dlwz: ret[0].diliweizhi, yxqx: ret[0].youxiaoqixian}
        this.jcssimg = ret[0].thumb2
        this.srcList.push(this.jcssimg)
        this.menudata[0].label2 = ret[0].kqqs
        this.menudata[1].label2 = ret[0].kyqlx
        this.menudata[2].label2 = ret[0].zyl
        this.menudata[3].label2 = ret[0].hzyx
        this.menudata[4].label2 = ret[0].xmys
        this.menudata[5].label2 = ret[0].dlwz
        this.menudata[6].label2 = this.formatTime(ret[0].addtime)
        this.title = ret[0].title
        this.message = {name: ret[0].truename, telephone: ret[0].telephone, mobile: ret[0].mobile, dq: ret[0].email, address: ret[0].address, disclaimers: ret[0].disclaimers}
      })
      let paras2 = {cmd: 'query', _major: 11, _minor: 130, _exp: 'id=?', types: 'i', vals: num}
      window.post.getPost(paras2).then((ret) =>
      {
        this.xcontent = window.public.decodeContent(ret[0].content)
      })
      let paras3 = {cmd: 'query', _major: 11, _minor: 129, _exp: 'examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 100}
      window.post.getPost(paras3).then((ret) =>
      {
        let temp = []
        ret[0].data.forEach(item =>
        {
          temp.push({id: item.id, title: item.title, pic: item.thumb ? item.thumb : 'static/images/moren.jpg'})
        })
        this.interestedList = temp
        this.changePic()
      })
    },
    // 获取公司id
    getCompany(str)
    {
      let paras = {cmd: 'query', _major: 11, _minor: 129, _exp: `company='${str}'`}
      window.post.getPost(paras).then((ret) =>
      {
        if (ret.length === 1)
          this.companyID = ret[0].id
      })
    },
    gotoCompany()
    {
      let url = this.$router.resolve({path: '/CompanyShow', query: {id: this.companyID}})
      window.open(url.href, '_blank')
    },
    // 当前信息过多时，点击查看更多进行展示
    lookmore()
    {
      this.show = !this.show
      if (this.show)
      {
        $('.InfoCard .content').css('height', 'auto')
        $('.InfoCard .content').css('min-height', '602px')
      }
      else
        $('.InfoCard .content').css('height', '602px')
    },
    // 加载更多
    changePic()
    {
      this.current += 1
      if (this.interestedList.length - this.current * 4 > 0)
      {
        for (let i = 0; i < 4; i++)
          this.datalist[i] = this.interestedList[i + (this.current - 1) * 4]
      }
      else
      {
        if (this.interestedList.length - this.current * 4 > -4)
        {
          for (let i = 0; i < this.interestedList.length - (this.current - 1) * 4; i++)
            this.datalist[i] = this.interestedList[i + (this.current - 1) * 4]
          for (let i = this.interestedList.length - (this.current - 1) * 4; i < 4; i++)
            this.datalist[i] = this.interestedList[i - 1]
        }
        else
        {
          for (let i = 0; i < 4; i++)
            this.datalist[i] = this.interestedList[i]
          this.current = 0
        }
      }
    },
    clickPic(item)
    {
      let url = this.$router.resolve({path: '/KyqtjDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    },
    // 绘制点
    drawPoint(val)
    {
      let rome = new Feature({
        geometry: new Point([val.split(',')[0], val.split(',')[1]]), //几何信息
        name: val.name
      })
      let vector = new VectorSource()
      vector.addFeature(rome)
      this.wfsVectorLayer = new VectorLayer({
        source: vector,
        style: new Style({
          image: new Icon({
            color: '#1296db',
            crossOrigin: 'anonymous',
            src: 'static/index/didian.png',
            label: val.name
          })
        })
      })
      // this.pointAry.push(this.wfsVectorLayer)
      window.map.addLayer(this.wfsVectorLayer)
      window.map.getView().setCenter([val.split(',')[0], val.split(',')[1]])
      window.map.getView().setZoom(11)
    },
    /***
	  	绘制多边形
	  	points：多边形顶点组成的列表
	  */
    drawPolygon(points)
    {
      for (let i = 0; i < points.split(';').length; i++)
        this.polyData.push([Number(points.split(';')[i].split(',')[0]), Number(points.split(';')[i].split(',')[1])])
      const styles = [
        new Style({
          stroke: new Stroke({
            color: 'blue',
            width: 3
          }),
          fill: new Fill({
            color: 'rgba(0, 0, 255, 0.1)'
          })
        }),
        new Style({
          image: new CircleStyle({
            radius: 5,
            fill: new Fill({
              color: 'orange'
            })
          }),
          geometry: function(feature)
          {
            // return the coordinates of the first ring of the polygon
            const coordinates = feature.getGeometry().getCoordinates()[0]
            return new MultiPoint(coordinates)
          }
        })
      ]

      const geojsonObject = {
        'type': 'FeatureCollection',
        'crs': {
          'type': 'name',
          'properties': {
            'name': 'EPSG:4326'
          }
        },
        'features': [
          {
            'type': 'Feature',
            'geometry': {
              'type': 'Polygon',
              'coordinates': [this.polyData]
            }
          }
        ]
      }

      const source = new VectorSource({
        features: new GeoJSON().readFeatures(geojsonObject)
      })
      let vlayer = new VectorLayer({
        title: 'polygon',
        type: 'polygon',
        source: source,
        style: styles
      })
      window.map.addLayer(vlayer)
      window.map.getView().setCenter([points.split(';')[0].split(',')[0], points.split(';')[0].split(',')[1]])
      window.map.getView().setZoom(12)
    },
    // 根据图层title获取地图图层，如果有就返回图层，没有就返回null
    getLayerInMap(map, name)
    {
      let layers = map.getLayers()   // 获取地图所有图层
      let layer = null
      layers.forEach((item, index) =>
      {
        if (item.values_.title !== undefined)
        {
          if (item.values_.title === name)
          {
            layer = item
            return layer
          }
        }
      })
      return layer
    },
    formatTime(value)
    {
      if (typeof (value) === 'undefined')
        return ''
      else
      {
        let date = new Date(parseInt(value * 1000))
        let y = date.getFullYear()
        let MM = date.getMonth() + 1
        MM = MM < 10 ? ('0' + MM) : MM
        let d = date.getDate()
        d = d < 10 ? ('0' + d) : d
        let h = date.getHours()
        h = h < 10 ? ('0' + h) : h
        let m = date.getMinutes()
        m = m < 10 ? ('0' + m) : m
        let s = date.getSeconds()
        s = s < 10 ? ('0' + s) : s
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/KyqtjDetails.vue